import { formatCurrency } from "./utils";

export interface SessionSummaryData {
  date: string;
  results: {
    name: string;
    totalNet: number;
    buyIns: number;
  }[];
  totalCashOut?: number;
  totalExpenses?: number;
  venue?: string | null;
}

export interface SettlementSummaryData {
  playerTotals: {
    name: string;
    net: number;
  }[];
  transfers: {
    from: string;
    to: string;
    amount: number;
  }[];
  pendingVolume: number;
}

export function formatSessionSummary(data: SessionSummaryData, url?: string): string {
  const dateStr = new Date(data.date).toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric', 
    year: 'numeric' 
  });
  
  const resultsSummary = data.results.map((r, i) => 
    `${i + 1}. ${r.name}: ${r.totalNet >= 0 ? '+' : ''}${Math.round(r.totalNet)} (${r.buyIns} buy-ins)`
  ).join('\n');
  
  let text = `🃏 SSC Results - ${dateStr}\n`;
  if (data.venue) text += `📍 Venue: ${data.venue}\n`;
  text += `\n${resultsSummary}\n`;
  
  if (data.totalCashOut !== undefined || data.totalExpenses !== undefined) {
    text += `\n--- Financials ---\n`;
    if (data.totalCashOut !== undefined) text += `💰 Total Cash Out: ${formatCurrency(data.totalCashOut)}\n`;
    if (data.totalExpenses !== undefined) text += `🧾 Total Expenses: ${formatCurrency(data.totalExpenses)}\n`;
  }
  
  if (url) text += `\n🔗 Full portal: ${url}`;
  
  return text;
}

export function formatSettlementSummary(data: SettlementSummaryData, url?: string): string {
  const dateStr = new Date().toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric', 
    year: 'numeric' 
  });
  
  const standings = data.playerTotals.map((pt) => 
    `${pt.name}: ${pt.net >= 0 ? '+' : ''}${Math.round(pt.net)}`
  ).join('\n');
  
  const transferText = data.transfers.map((t) => 
    `${t.from} ➔ ${t.to}: ${formatCurrency(t.amount)}`
  ).join('\n');
  
  let text = `💰 SSC Settlement Summary - ${dateStr}\n`;
  text += `\n--- Standings ---\n${standings}\n`;
  
  if (transferText) {
    text += `\n--- How to Settle ---\n${transferText}\n`;
  }
  
  text += `\nTotal Pending: ${formatCurrency(data.pendingVolume)}`;
  
  if (url) text += `\n\n🔗 Full portal: ${url}`;
  
  return text;
}

export function shareToWhatsApp(text: string) {
  const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
  window.open(url, '_blank');
}
